import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {NavigationStart, Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {filter, takeWhile} from 'rxjs/operators';
import {BehaviorSubject} from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'pp-header',
    templateUrl: './header.component.html',
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {
    public isMobileMenuShow = false;
    private alive = true;

    public user: any;
    private $isMobileMenuShow = new BehaviorSubject(this.isMobileMenuShow);

    @Output() public toggleScrolling = new EventEmitter();

    constructor(private modalService: NgbModal,
                private auth: AuthService,
                private router: Router) {}

    public ngOnInit() {


        this.router.events
            .pipe(
                filter(event => event instanceof NavigationStart),
                takeWhile(() => this.alive))
            .subscribe(ev => {
                this.$isMobileMenuShow.next(false);
            });

        this.$isMobileMenuShow.subscribe(value => {
            this.toggleScrolling.emit(value);
            this.isMobileMenuShow = value;
        });
    }

    public ngOnDestroy() {
        this.alive = false;
    }

    public toggleMobileMenu(event) {
        event.preventDefault();
        this.$isMobileMenuShow.next(!this.isMobileMenuShow);
    }

    public closeMobileMenu(event) {
        event.preventDefault();
        this.$isMobileMenuShow.next(false);
    }

    public toggleLang(isOpen) {
        if (isOpen) {
            this.$isMobileMenuShow.next(false);
        }
        if (!this.isMobileMenuShow) {
            this.toggleScrolling.emit(isOpen);
        }
    }
}

